module.exports = __webpack_public_path__ + "img/zz8.ee726e0e.png";